import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, get } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface InvoiceExportApiParameter extends ApiParameter {
    customerSequence?: string;
    sort?: string;
    dateType?: string;
    toDate?: string;
    fromDate?: string;
    invoiceType?: string;
    invoiceTypeDesc?: string;
    isSearch?: boolean;
    showOpenOnly?: boolean;
    dateRange?: string;
    dateRangeDesc?: string;
    invoiceFilterType?: string;
    invoiceFilterData?: string;
    dpdFilterType?: string;
    dpdFilterData?: string;
    properties?: any;
    page?: string;
    pageSize?: string;
}

export interface InvoiceExportModel extends BaseModel {
    fileName: string;
}

const invoiceExportURL = "/api/v3/exportinvoice";

export async function getExportFile(parameter: InvoiceExportApiParameter): Promise<ServiceResult<InvoiceExportModel>> {
    try {
        const getExportFile = await get<InvoiceExportModel>(invoiceExportURL, parameter);
        return {
            result: getExportFile,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
